var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-group-item",class:{'list-group-item-accent-danger' : _vm.eventDateHasRequiredProducts&&!_vm.bookingHasActivePurchase, 'list-group-item-accent-light' : !_vm.eventDateHasRequiredProducts||_vm.bookingHasActivePurchase}},[_c('Request',{ref:"requestChangeQuantity",attrs:{"onRequestSuccess":_vm.onRequestSuccessChangeQuantity,"method":"PUT","root":"/event-booking-panel/change-quantity"}},[_vm._t("default",[_c('Request',{ref:"requestChangeStatus",attrs:{"onRequestSuccess":_vm.onRequestSuccessChangeStatus,"method":"PUT","root":"/event-booking-panel/change-status"}},[_vm._t("default",[_c('Request',{ref:"requestLinkPurchase",attrs:{"onRequestSuccess":_vm.onRequestSuccessLinkPurchase,"method":"PUT","root":"/event-booking-panel/link-purchase"}},[_vm._t("default",[_c('div',{staticClass:"d-flex w-100 justify-content-between"},[_c('strong',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.Core.User.displayName(_vm.booking.userFirstname, _vm.booking.userLastname, _vm.booking.userEmail, _vm.booking.userPhone, _vm.booking.userId)))]),_c('b-button-group',{staticClass:"btn-group-sm"},[(_vm.userNormalNotes.length > 0)?_c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){return _vm.onOpenNotesClick('normal')}}},[_c('i',{staticClass:"fa fa-warning"}),_vm._v(" "+_vm._s(_vm.userNormalNotes.length))]):_vm._e(),(_vm.userCriticalNotes.length > 0)?_c('b-button',{attrs:{"variant":"info"},on:{"click":function($event){return _vm.onOpenNotesClick('critical')}}},[_c('i',{staticClass:"fa fa-comment"}),_vm._v(" "+_vm._s(_vm.userCriticalNotes.length))]):_vm._e(),_c('b-dropdown',{staticClass:"btn-group-sm ml-2 btn-square",attrs:{"text":"Options","variant":"light"}},[_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){_vm.$router.push(_vm.Core.Text.format(_vm.Core.Definition.getDefinition('/systeme/utilisateurs/{0}'),_vm.booking.userId))}}},[_c('i',{staticClass:"fa fa-user mr-2"}),_vm._v(_vm._s(_vm.Core.Definition.getDefinition('Voir le profil')))]),(_vm.Core.Session.AuthUser.can('event_booking_management_put_update_booking') && _vm.booking.status !== _vm.Mantle.EventDateBooking.statusWaiting && _vm.completeDisplay)?_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.onChangeStatusClick(_vm.Mantle.EventDateBooking.statusWaiting)}}},[_c('i',{staticClass:"fa fa-pause mr-2"}),_vm._v(_vm._s(_vm.Core.Definition.getDefinition('Mettre en attente')))]):_vm._e(),(_vm.Core.Session.AuthUser.can('event_booking_management_put_update_booking') && _vm.booking.status !== _vm.Mantle.EventDateBooking.statusRegistered && _vm.completeDisplay)?_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.onChangeStatusClick(_vm.Mantle.EventDateBooking.statusRegistered)}}},[_c('i',{staticClass:"fa fa-check mr-2"}),_vm._v(_vm._s(_vm.Core.Definition.getDefinition('Confirmer participation')))]):_vm._e(),(_vm.Core.Session.AuthUser.can('event_booking_management_put_update_booking') && _vm.booking.status !== _vm.Mantle.EventDateBooking.statusCancelled)?_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.onChangeStatusClick(_vm.Mantle.EventDateBooking.statusCancelled)}}},[_c('i',{staticClass:"fa fa-times mr-2"}),_vm._v(_vm._s(_vm.Core.Definition.getDefinition('Annuler')))]):_vm._e(),(false)?_c('b-dropdown-item',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-location-arrow mr-2"}),_vm._v(_vm._s(_vm.Core.Definition.getDefinition('Déplacer vers ...')))]):_vm._e(),(false)?_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.onChangeStatusClick(_vm.Core.Instance.statusArchive)}}},[_c('i',{staticClass:"fa fa-trash mr-2"}),_vm._v(_vm._s(_vm.Core.Definition.getDefinition('Supprimer')))]):_vm._e()],1)],1)],1),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"lg":"1","md":"2","sm":"12"}},[_c('img',{attrs:{"width":"100%","src":_vm.Core.User.displayAvatar(_vm.booking.userAvatar, _vm.booking.userAvatarDefault)}})]),_c('b-col',{attrs:{"lg":"6","md":"6","sm":"12"}},[_c('small',[_c('span',[_vm._v("ID: "+_vm._s(_vm.booking.userId))]),_c('br'),_c('span',[_vm._v(_vm._s(_vm.Core.User.displayPhone(_vm.booking.userPhone, _vm.booking.userMobile)))]),_c('br'),_c('span',[_vm._v(_vm._s(_vm.booking.userEmail))])]),_c('br'),_c('div',{staticClass:"mt-3"},[(_vm.Core.Session.AuthUser.can('event_booking_management_put_update_booking'))?_c('InputQuantity',{staticClass:"mr-2 pull-left",attrs:{"displayOnChangeValid":true,"max":_vm.bookingActiveProductBookingLimit,"description":_vm.bookingActivePurchaseBookingCountDescription},on:{"onValidClick":_vm.onValidQuantityClick},model:{value:(_vm.booking.quantity),callback:function ($$v) {_vm.$set(_vm.booking, "quantity", $$v)},expression:"booking.quantity"}}):_vm._e(),(_vm.completeDisplay && _vm.Core.Session.AuthUser.can('event_booking_management_put_update_booking'))?_c('b-button-group',{staticClass:"btn-group-sm pull-left"},[_c('b-button',{class:{ 'btn-success': _vm.booking.status === _vm.Mantle.EventDateBooking.statusPresent, 'btn-light' : _vm.booking.status !== _vm.Mantle.EventDateBooking.statusPresent },on:{"click":function($event){return _vm.onChangeStatusClick(_vm.Mantle.EventDateBooking.statusPresent)}}},[_vm._v(_vm._s(_vm.Core.Definition.getDefinition('Présent')))]),_c('b-button',{class:{ 'btn-warning': _vm.booking.status === _vm.Mantle.EventDateBooking.statusAWR, 'btn-light' : _vm.booking.status !== _vm.Mantle.EventDateBooking.statusAWR },on:{"click":function($event){return _vm.onChangeStatusClick(_vm.Mantle.EventDateBooking.statusAWR)}}},[_vm._v(_vm._s(_vm.Core.Definition.getDefinition('Abs. motivée')))]),_c('b-button',{class:{ 'btn-danger': _vm.booking.status === _vm.Mantle.EventDateBooking.statusAWNR, 'btn-light' : _vm.booking.status !== _vm.Mantle.EventDateBooking.statusAWNR },on:{"click":function($event){return _vm.onChangeStatusClick(_vm.Mantle.EventDateBooking.statusAWNR)}}},[_vm._v(_vm._s(_vm.Core.Definition.getDefinition('Abs. non-motivée')))])],1):_vm._e()],1)]),_c('b-col',{attrs:{"lg":"5","md":"4","sm":"12"}},[(_vm.booking.status !== _vm.Mantle.EventDateBooking.statusCancelled)?_c('div',{staticClass:"text-right"},[(!_vm.bookingHasActivePurchase)?_c('b-button-group',{staticClass:"btn-group-sm btn-square mt-3"},[_c('b-button',{attrs:{"variant":"warning"}},[_vm._v(_vm._s(_vm.Core.Definition.getDefinition('Aucun produit associé')))]),_c('b-dropdown',{staticClass:"btn-group-sm",attrs:{"right":"","variant":"warning"}},[(_vm.Core.Session.AuthUser.can('event_booking_management_put_link_purchase'))?_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){_vm.$refs.modalInstanceSelectorActivePurchase.open = true}}},[_c('i',{staticClass:"fa fa-link mr-2"}),_vm._v(_vm._s(_vm.Core.Definition.getDefinition('Associer un achat')))]):_vm._e(),(_vm.Core.Session.AuthUser.can('event_booking_management_put_link_purchase'))?_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){_vm.$refs.modalInstanceSelectorNewPurchase.open = true}}},[_c('i',{staticClass:"fa fa-shopping-cart mr-2"}),_vm._v(_vm._s(_vm.Core.Definition.getDefinition('Nouvel achat')))]):_vm._e()],1)],1):_c('b-button-group',{staticClass:"btn-group-sm btn-square mt-3"},[_c('b-button',{attrs:{"variant":"info"},on:{"click":_vm.bookingActivePurchaseRoute}},[_vm._v(_vm._s(_vm.bookingActivePurchaseTitle))]),_c('b-dropdown',{staticClass:"btn-group-sm",attrs:{"right":"","variant":"info"}},[(_vm.Core.Session.AuthUser.can('event_booking_management_put_unlink_purchase'))?_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){_vm.$refs.modalConfirmUnlinkPurchase.open = true}}},[_c('i',{staticClass:"fa fa-unlink mr-2"}),_vm._v(_vm._s(_vm.Core.Definition.getDefinition('Dissocier l\'achat')))]):_vm._e()],1)],1)],1):_vm._e()])],1),(_vm.eventDateHasRequiredProducts&&!_vm.bookingHasActivePurchase)?_c('b-row',[_c('b-col',[_c('b-alert',{attrs:{"show":"","variant":"warning"}},[_vm._v("\n                                        "+_vm._s(_vm.Core.Definition.getDefinition('Le client ne détient aucun des produits requis par l\'événement'))+"\n                                    ")])],1)],1):_vm._e(),(_vm.booking.status !== _vm.Mantle.EventDateBooking.statusCancelled)?_c('small',[_vm._v(_vm._s(_vm.Core.Definition.getDefinition('Réservation:'))+" "+_vm._s(_vm.Core.Date.readableDate(_vm.booking.bookDate, 'DD MMM YYYY HH:mm')))]):_vm._e(),(_vm.booking.cancelDate !== '' && _vm.booking.status === _vm.Mantle.EventDateBooking.statusCancelled)?_c('small',[_vm._v(_vm._s(_vm.Core.Definition.getDefinition('Annulation:'))+" "+_vm._s(_vm.Core.Date.readableDate(_vm.booking.cancelDate, 'DD MMM YYYY HH:mm')))]):_vm._e()],{"slot":"body"})],2)],{"slot":"body"})],2)],{"slot":"body"})],2),_c('Modal',{ref:"modalOkNotes",attrs:{"closeOnOk":true,"caption":_vm.Core.Definition.getDefinition('Notes')}},[_vm._t("default",[_c('b-list-group',{staticClass:"list-group-accent"},_vm._l((_vm.dataNotes),function(note,noteIndex){return _c('b-list-group-item',{key:noteIndex,attrs:{"href":"#"}},[_c('div',{staticClass:"pb-2"},[_vm._v("\n                        "+_vm._s(note.message)+"\n                    ")]),_c('small',{staticClass:"text-muted mr-3"},[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" "+_vm._s(_vm.Core.Definition.getDefinition('Créé le'))+" "+_vm._s(_vm.Core.Date.format(note.creationDate, 'DD MMM YYYY'))+"\n                    ")])])}),1)],{"slot":"body"})],2),_c('ModalInstanceSelector',{ref:"modalInstanceSelectorNewPurchase",attrs:{"root":"/product/list","multiple":false,"searchFormStructure":{
                rows: [
                     {
                        cols: [

                            {
                                fields: [
                                    {
                                        id: 'forceRequiredProducts'
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        cols: [
                            {
                               fields: [
                                   {
                                       id: 'id'
                                   }
                               ]
                            },
                            {
                                fields: [
                                    {
                                       id: 'title'
                                    }
                                ]
                             }
                        ]
                    },
                    {
                        cols: [
                            {
                               fields: [
                                   {
                                       id: 'type'
                                   }
                               ]
                            },
                            {}
                        ]
                    }
                ],
                fields: [
                    {
                        id: 'forceRequiredProducts',
                        type: 'checkbox',
                        labelCols: 6,
                        label: _vm.Core.Definition.getDefinition('Afficher seulement les produits requis par l\'événement'),
                        value: true,
                        onChange: function() {}
                    },
                    {
                        id: 'id',
                        type: 'number',
                        label: _vm.Core.Definition.getDefinition('ID'),
                        value: ''
                    },
                    {
                        id: 'title',
                        type: 'text',
                        label: _vm.Core.Definition.getDefinition('Titre'),
                        value: ''
                    },
                    {
                        id: 'type',
                        type: 'select',
                        label: _vm.Core.Definition.getDefinition('Type'),
                        value: null,
                        onSelect: function() {}
                    }
                ]
            },"searchArgs":[
                    {
                        key: 'id',
                        value: _vm.eventDateRequiredProductIds
                    },
                    {
                        key: 'type',
                        value: [_vm.Core.Product.typeStandard, _vm.Core.Product.typeRecurringSubscription, _vm.Core.Product.typeLimitedSubscription]
                    }
            ],"options":{
                        pagination: true,
                        header: true,
                        responsive: false,
                        striped: true,
                        headerStyle: '1',
                        emptyText: _vm.Core.Definition.getDefinition('Aucun produit à afficher'),
                        borderVariant: 'white',
                        noBody: true
                 },"columns":[
                        {
                            label: _vm.Core.Definition.getDefinition('#'),
                            key: 'id',
                            sortable: true
                        },
                        {
                            label: _vm.Core.Definition.getDefinition('Titre'),
                            key: 'title',
                            sortable: true
                        },
                        {
                            label: _vm.Core.Definition.getDefinition('Type'),
                            key: 'type',
                            sortable: true
                        },
                        {
                            label: _vm.Core.Definition.getDefinition('Prix régulier'),
                            key: 'Readable.regularPrice',
                            type: 'text',
                            sortable: true
                        }
                 ]},model:{value:(_vm.dataNewPurchase),callback:function ($$v) {_vm.dataNewPurchase=$$v},expression:"dataNewPurchase"}}),_c('ModalInstanceSelector',{ref:"modalInstanceSelectorActivePurchase",attrs:{"caption":_vm.Core.Definition.getDefinition('Achats actifs'),"root":"/event-booking-panel/active-purchases","multiple":false,"searchFormStructure":{
            rows: [
                {
                    cols: [
                        {
                            fields: [
                                {
                                    id: 'userFirstname'
                                }
                            ]
                        },
                        {
                            fields: [
                                {
                                    id: 'userLastname'
                                }
                            ]
                        } ]
                },
                {
                    cols: [

                        {
                            fields: [
                                {
                                    id: 'userEmail'
                                }
                            ]
                        },
                        {
                            fields: [
                                {
                                    id: 'userPhone'
                                }
                            ]
                        }
                    ]
                },
                 {
                    cols: [

                        {
                            fields: [
                                {
                                    id: 'forceRequiredProducts'
                                }
                            ]
                        }

                    ]
                }
            ],
            fields: [
                {
                    id: 'userFirstname',
                    type: 'text',
                    label: _vm.Core.Definition.getDefinition('Prénom'),
                    value: ''
                },
                {
                    id: 'userLastname',
                    type: 'text',
                    label: _vm.Core.Definition.getDefinition('Nom de famille'),
                    value: ''
                },
                {
                    id: 'userPhone',
                    type: 'text',
                    label: _vm.Core.Definition.getDefinition('Téléphone'),
                    value: ''
                },
                {
                    id: 'userEmail',
                    type: 'text',
                    label: _vm.Core.Definition.getDefinition('Courriel'),
                    value: ''
                },
                {
                    id: 'forceRequiredProducts',
                    type: 'checkbox',
                    labelCols: 4,
                    label: _vm.Core.Definition.getDefinition('Afficher seulement achats qui contient un produit requis par l\'événement'),
                    value: true,
                    onChange: function() {}
                }
            ]
        },"searchArgs":[
                    {
                        key: 'requiredProductIds',
                        value: this.eventDateRequiredProductIds
                    },
                    {
                        key: 'userId',
                        value: _vm.booking.userId
                    }
                ],"options":{
                        pagination: true,
                        header: true,
                        responsive: false,
                        striped: true,
                        headerStyle: '1',
                        emptyText: _vm.Core.Definition.getDefinition('Aucun achat à afficher'),
                        borderVariant: 'white',
                        noBody: true
                 },"columns":[
                        {
                            label: _vm.Core.Definition.getDefinition('ID'),
                            key: 'purchaseId',
                            sortable: true
                        },
                        {
                            label: _vm.Core.Definition.getDefinition('Prénom'),
                            key: 'userBillingFirstname',
                            type: 'text',
                            sortable: true
                        },
                        {
                            label: _vm.Core.Definition.getDefinition('Nom de famille'),
                            key: 'userBillingLastname',
                            type: 'text',
                            sortable: true
                        },
                        {
                            label: _vm.Core.Definition.getDefinition('Produit'),
                            key: 'productTitle',
                            type: 'text',
                            sortable: true
                        },
                        {
                            label: _vm.Core.Definition.getDefinition('Date de création'),
                            key: 'creationDate',
                            type: 'date',
                            sortable: true
                        }
                 ]},model:{value:(_vm.dataActivePurchases),callback:function ($$v) {_vm.dataActivePurchases=$$v},expression:"dataActivePurchases"}}),_c('ModalConfirm',{ref:"modalConfirmUnlinkPurchase",attrs:{"closeOnConfirm":false,"caption":_vm.Core.Definition.getDefinition('Dissocier l\'achat')},on:{"onConfirm":_vm.onConfirmUnlinkPurchase}},[_vm._t("default",[_c('Request',{ref:"requestUnlinkPurchase",attrs:{"onRequestSuccess":_vm.onRequestSuccessUnlinkPurchase,"method":"PUT","root":"/event-booking-panel/unlink-purchase"}},[_vm._t("default",[_c('p',[_vm._v(_vm._s(_vm.Core.Definition.getDefinition('Voulez-vous vraiment dissocier l\'achat de cette réservation?')))])],{"slot":"body"})],2)],{"slot":"body"})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }